import React, { useEffect } from "react";
import SEO from "../component/SEO";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts, fetchCategories } from "../redux/productSlice";
import AllProduct from "../component/AllProduct";
import { useParams } from "react-router-dom";

const Menu = () => {
  const dispatch = useDispatch();
  const { productList, status, categoryStatus } = useSelector((state) => state.product);
  const { category } = useParams(); // 👈 capture category from URL (like /menu/cakes)

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchProducts());
    }
    if (categoryStatus === "idle") {
      dispatch(fetchCategories());
    }
  }, [dispatch, status, categoryStatus]);

  
  if (status === "loading") {
    return (
      <p className="p-4 text-center text-[#8B5E3C] animate-pulse">
        Loading products...
      </p>
    );
  }

  if (productList.length === 0) {
    return (
      <p className="p-4 text-center text-[#8B5E3C]">No products available.</p>
    );
  }

  return (
    <div className="relative min-h-screen w-full bg-gradient-to-b from-pink-50 via-orange-50 to-purple-50 overflow-hidden py-10 px-6 md:px-10">
      <SEO title="Our Menu - K Bakery" description="Explore our delicious menu of cakes, pastries, and more." />
      {/* === Animated Backgrounds === */}
      <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-br from-[#FFD4A3]/50 to-[#E5DEFF]/40 rounded-full float-animation"></div>
      <div
        className="absolute bottom-10 right-20 w-96 h-96 bg-gradient-to-br from-[#E8F4F8]/50 to-[#FFB4AB]/40 rounded-full float-animation"
        style={{ animationDelay: "2s" }}
      ></div>
      <div
        className="absolute top-1/3 right-1/4 w-80 h-80 bg-gradient-to-br from-[#FFB4AB]/30 to-[#E5DEFF]/20 rounded-[60%_40%_50%_70%/60%_30%_70%_50%] blob-animation"
        style={{ animationDelay: "4s" }}
      ></div>

      {/* Content */}
      <div className="relative z-10">
        <AllProduct heading="" initialCategory={category} />
      </div>

      {/* Floating animation styles */}
      <style jsx global>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-25px);
          }
        }
        .float-animation {
          animation: float 6s ease-in-out infinite;
        }

        @keyframes blob {
          0%, 100% {
            border-radius: 40% 60% 70% 30% / 40% 40% 60% 60%;
            transform: rotate(0deg) scale(1);
          }
          50% {
            border-radius: 70% 30% 40% 60% / 50% 60% 40% 50%;
            transform: rotate(10deg) scale(1.05);
          }
        }
        .blob-animation {
          animation: blob 14s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Menu;
